import { description, firmware_needed } from "translations-de";

export const de ={
    "app_name": "Fernzugriff",
    "alert_default_text": "Ein Fehler ist aufgetreten!",
    "alert_default_success": "Erfolg!",
    description,
    "no_service_worker": "Dein Browser benötigt Unterstützung für ServiceWorker um den Fernzugriff nutzen zu können.",
    "banner": {
        "title": "Bevorstehende Wartungsarbeiten!",
        "message": "Wartungsarbeiten sind für Montag, den 01.12.2025 von 10:00 Uhr bis 11:30 Uhr geplant. Währenddessen ist der Fernzugriff nicht erreichbar."
    },
    "not_now": "Jetzt nicht",
    "allow": "Browserdialog anzeigen",
    "storage_persistence": {
        "title": "Angemeldet bleiben",
        "body": "Wir verwenden den Speicher deines Browsers, um dich angemeldet zu halten. Einige Browser löschen diese Daten automatisch (z. B. bei wenig Speicherplatz oder nach einiger Zeit). Das Zulassen von dauerhaftem Speicher hilft unerwartete Abmeldungen zu vermeiden. Nachdem du auf \"Browserdialog anzeigen\" klickst, zeigt dir dein Browser einen Berechtigungsdialog zur Bestätigung an.",
        "remember_choice": "Nicht mehr fragen"
    },
    "user": {
        "account_actions": "Kontoaktionen",
        "profile_information": "Kontoinformationen",
        "save_changes": "Änderungen speichern",
        "user_id": "Konto-ID",
        "email": "E-Mail-Adresse",
        "name": "Name",
        "change": "Ändern",
        "change_password": "Passwort ändern",
        "change_password_button": "Passwort ändern",
        "current_password": "Aktuelles Passwort",
        "current_password_error_message": "Darf nicht leer sein.",
        "new_password": "Neues Passwort",
        "new_password_error_message": "Muss mindestens 8 Zeichen lang sein.",
        "confirm_new_password": "Neues Passwort bestätigen",
        "confirm_new_password_error_message": "Passwörter stimmen nicht überein",
        "close": "Schließen",
        "delete_user": "Konto löschen",
        "delete_user_button": "Konto löschen",
        "password": "Passwort",
        "password_invalid": "Passwort falsch",
        "invalid_name": "Name darf nicht leer sein.",
        "logout_all": "Von allen Sessions ausloggen",
        "get_user_failed": "Laden der Kontodaten mit dem Code {{status}} fehlgeschlagen: {{response}}",
        "update_user_failed": "Aktualisieren der Kontodaten mit dem Code {{status}} fehlgeschlagen: {{response}}",
        "update_password_failed": "Aktualisieren des Passwortes mit dem Code {{status}} fehlgeschlagen: {{response}}",
        "delete_user_failed": "Löschen des Kontos mit dem Code {{status}} fehlgeschlagen: {{response}}",
        "email_change_disabled": "Ändern der E-Mail-Adresse ist deaktiviert, da Du Geräte mit alter Firmware-Version konfiguriert hast. Bitte aktualisiere zuerst deine Geräte.",
        "local_settings": "Lokale Einstellungen",
        "debug_mode": "Debug-Modus",
        "save_recovery_file": "Wiederherstellungsdatei speichern",
        "save_recovery_file_password": "Gib dein Passwort ein, um die Wiederherstellungsdatei herunterzuladen.",
        "save_recovery_file_failed": "Herunterladen der Wiederherstellungsdatei mit dem Code {{status}} fehlgeschlagen: {{response}}",
        "save_recovery_file_wrong_password": "Falsches Passwort. Entschlüsselung fehlgeschlagen.",
        "download": "Herunterladen",
    },
    "recovery": {
        "recovery": "Passwort zurücksetzen",
        "new_password": "Neues Passwort",
        "confirm_password": "Passwort bestätigen",
        "confirm_password_error_message": "Passwörter stimmen nicht überein",
        "recovery_file": "Wiederhestellungsdatei",
        "submit": "Abschicken",
        "invalid_file": "Datei ist beschädigt oder falsch",
        "token_expired": "Das Token ist abgelaufen. Bitte starte den Vorgang erneut.",
        "no_file_warning_heading": "Bist du sicher?",
        "no_file_warning_body": "Du hast keine Wiederherstellungsdatei angegeben. Wenn du fortfährst, wird ein neues Geräte-Secret erzeugt. Dadurch verlierst du den Zugriff auf alle deine Geräte und musst sie manuell erneut hinzufügen. Wenn du noch Zugriff auf deine Wiederherstellungsdatei hast, empfehlen wir dringend, diese zu verwenden.",
        "no_file_warning_cancel": "Abbrechen",
        "no_file_warning_proceed": "Ohne Datei fortfahren",
        "no_file_warning_ack": "Ich verstehe, dass das Fortfahren ohne Wiederherstellungsdatei meine Geräte trennt und ich sie erneut hinzufügen muss."
    },
    "chargers": {
        "loading": "Lädt...",
        "charger_name": "Name",
        "charger_id": "Geräte-ID",
        "mobile_charger_id": "UID",
        "status": "Status",
        "status_connected": "Verbunden",
        "status_disconnected": "Getrennt",
        "connect": "Verbinden",
        "remove": "Löschen",
        "close": "Schließen",
        "loading_secret_failed": "Laden des Secrets ist mit dem Code {{status}} fehlgeschlagen: {{response}}. Bitte lade die Seite neu.",
        "loading_keys_failed": "Laden des Verbindungsschlüssels mit dem code {{status}} fehlgeschlagen: {{response}}. Bitte lade die Seite neu.",
        "all_keys_in_use": "Zur Zeit sind alle Fernzugriffsverbindungen belegt",
        "no_keys": "Bitte lerne das Gerät erneut an",
        "loading_devices_failed": "Laden der Geräte ist mit dem Code {{status}} fehlgeschlagen: {{response}}. Bitte lade die Seite neu.",
        "no_devices": "Noch keine Geräte registriert. Bitte verbinde dein Gerät mit diesem Konto, um zu beginnen.",
        "connect_error_text": "Verbindung zu Gerät {{charger_id}} ist mit dem code {{status}} fehlgeschlagen: {{response}}. Bitte lade die Seite neu.",
        "remove_error_text": "Entfernen des Gerätes {{charger_id}} ist mit dem code {{status}} fehlgeschlagen: {{response}}. Bitte lade die Seite neu.",
        "delete_modal_heading": "Gerät {{name}} entfernen",
        "delete_modal_body": "Bist du sicher, dass du das Gerät {{name}} entfernen willst? Dies ist permanent und das Gerät kann nur wiederhergestellt werden wenn du direkten Zugriff auf das Webinterface hast.",
        "select_sorting": "Sortieren",
        "sorting_sequence_asc": "Aufsteigend",
        "sorting_sequence_desc": "Absteigend",
        "note": "Notiz",
        "firmware_version": "Firmwareversion",
        "last_state_change": "Statusänderung",
        "added_at": "Zu deinem Konto hinzugefügt",
        "time_just_now": "Gerade eben",
        "time_minutes_ago": "vor {{count}}m",
        "time_hours_ago": "vor {{count}}h",
        "time_days_ago": "vor {{count}}d",
        "edit_note_heading": "Notiz bearbeiten",
        "edit_note_failed": "Notiz bearbeiten fehlgeschlagen, bitte lade die Seite neu.",
        "accept": "Bestätigen",
        "decline": "Verwerfen",
        "show_more": "Mehr anzeigen",
        "show_less": "Weniger anzeigen",
        "abort": "Abbrechen",
        "not_connected": "Das Gerät ist aktuell nicht erreichbar. Sollte das Problem weiterhin bestehen, überprüfe bitte deine Internetverbindung und die Verbindung des Gerätes zum Internet.",
        "connecting": "Verbindung wird aufgebaut",
        "loading_webinterface": "Webinterface wird geladen",
        "invalid_key": "Die auf dem Gerät gespeicherten Schlüssel scheinen fehlerhaft zu sein. Sollte der Fehler weiterhin bestehen, entferne das Gerät und füge es erneut hinzu.",
        "websocket_parse_error": "Fehler beim Verarbeiten der Geräteaktualisierung vom Server.",
        "connection_timeout": "Timeout",
        "connection_timeout_text": "Ein Timeout ist während des Aufbaus der Verbindung aufgetreten. Bitte versuche es später erneut oder kontaktiere uns falls das Problem bestehen bleibt.",
        "search_devices": "Geräte suchen",
        "search_devices_placeholder": "Suche nach Name, ID, Notiz oder Status...",
        "clear_search": "Suche löschen",
        "no_devices_found": "Keine Geräte gefunden, die deiner Suche entsprechen.",
        "local": "Lokal",
        "connect_locally": "Lokal verbinden",
        "connect_via_cloud": "Über Fernzugriff verbinden",
        "manage_groupings": "Gruppen verwalten",
        "groupings": "Gruppen",
        "create_grouping": "Gruppe erstellen",
        "edit_grouping": "Gruppe bearbeiten",
        "delete_grouping": "Gruppe löschen",
        "grouping_name": "Gruppenname",
        "grouping_name_placeholder": "Gruppennamen eingeben...",
        "grouping_devices": "Geräte in Gruppe",
        "add_devices_to_grouping": "Geräte zur Gruppe hinzufügen",
        "remove_device_from_grouping": "Aus Gruppe entfernen",
        "no_groupings": "Noch keine Gruppen erstellt",
        "no_groupings_found": "Keine Gruppen gefunden, die deiner Suche entsprechen.",
        "create_grouping_success": "Gruppe erfolgreich erstellt",
        "update_grouping_success": "Gruppe erfolgreich aktualisiert",
        "delete_grouping_success": "Gruppe erfolgreich gelöscht",
        "create_grouping_failed": "Gruppe konnte nicht erstellt werden: {{error}}",
        "update_grouping_failed": "Gruppe konnte nicht aktualisiert werden: {{error}}",
        "delete_grouping_failed": "Gruppe konnte nicht gelöscht werden: {{error}}",
        "add_device_to_grouping_failed": "Gerät konnte nicht zur Gruppe hinzugefügt werden: {{error}}",
        "remove_device_from_grouping_failed": "Gerät konnte nicht aus der Gruppe entfernt werden: {{error}}",
        "load_groupings_failed": "Gruppen konnten nicht geladen werden: {{error}}",
        "delete_grouping_confirm": "Bist du sicher, dass du die Gruppe \"{{name}}\" löschen möchtest?",
        "all_devices": "Alle Geräte",
        "filter_by_grouping": "Nach Gruppe filtern",
        "grouping_empty": "Diese Gruppe enthält keine Geräte",
        "select_devices": "Geräte zum Hinzufügen auswählen",
        "search_groupings": "Suchen",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "set_as_default": "Als Standard festlegen",
        "default_grouping": "Standard",
        "set_as_default_replaces": "Dies ersetzt \"{{name}}\" als Standardgruppe.",
        "set_default_failed": "Standardgruppe konnte nicht gesetzt werden: {{error}}",
        "no_group": "Keine Gruppe",
        "local_devices": "Lokale Geräte",
        "group_by_toggle": "Geräte nach Gruppe anordnen",
        "group_by_on": "Gruppiert",
        "group_by_off": "Flach"
    },
    "navbar": {
        "home": "Home",
        "chargers": "Geräte",
        "logout": "Ausloggen",
        "token": "Token",
        "close": "Schließen"
    },
    "register": {
        "register": "Registrieren",
        "name": "Name",
        "name_error_message": "Der Name darf nicht leer sein",
        "email": "E-Mail-Adresse",
        "email_error_message": "Die E-Mail-Adresse, darf nicht leer sein",
        "password": "Passwort",
        "password_error_message": "Muss mindestens 8 Zeichen lang sein und jeweils mindestens einen Klein- und Großbuchstaben sowie eine Zahl enthalten.",
        "confirm_password": "Passwort bestätigen",
        "confirm_password_error_message": "Passwörter stimmen nicht überein",
        "accept_privacy_notice": "Ich habe die <0>Datenschutzerklärung</0> gelesen, verstanden und stimme zu.",
        "accept_terms_and_conditions": "Ich habe die <0>AGB</0> gelesen, verstanden und stimme zu.",
        "save_recovery_data": "Wiederherstellungsdatei speichern",
        "save": "Speichern",
        "save_recovery_data_text": "Da die Zugangsdaten für die Geräte nur mit Hilfe des korrekten Passworts entschlüsselt werden können brauchst du, falls du dein Passwort vergessen solltest, diese Datei um den Zugang zu deinen Geräten wiederherzustellen. Bewahre diese Datei sicher und für niemanden sonst zugänglich auf, da sie mit deinem Passwort gleichzustellen ist.",
        "save_recovery_data_confirmation": "Ich habe die Wiederherstellungsdatei heruntergeladen und sicher gespeichert",
        "close": "Schließen",
        "registration_successful": "Die Registrierung war erfolgreich. Du solltest innerhalb der nächsten paar Minuten eine Email mit einem Bestätigungslink erhalten",
        "email_already_exists": "Ein Konto mit dieser E-Mail-Adresse existiert bereits."
    ,"resend_verification": "Bestätigungs-E-Mail erneut senden"
    ,"resend_success": "Bestätigungs-E-Mail gesendet (falls noch nicht bestätigt)."
    ,"resend_error": "Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte versuche es später erneut."
    },
    "login": {
        "password_recovery": "Passwort zurücksetzen",
        "email":"E-Mail-Adresse",
        "send": "Senden",
        "close": "Schließen",
        "password": "Passwort",
        "login": "Anmelden",
        "wrong_credentials": "E-Mail-Adresse oder Passwort falsch.",
        "success_alert_text": "Du solltest innerhalb der nächsten Minuten eine E-Mail erhalten.",
        "success_alert_heading": "Erfolg",
        "error_alert_text": "Failed to start recovery with status {{status}}: {{text}}",
        "verify_before_login": "Bitte bestätige deine E-Mail-Adresse, bevor du dich anmeldest",
        "verify_before_login_heading": "E-Mail-Adresse nicht bestätigt",
        "verify_success": "Dein Konto wurde bestätigt. Du kannst dich jetzt anmelden.",
        "verify_success_heading": "Konto aktiviert"
    },
    "password_strength": {
        "strength": "Stärke",
        "entropy": "Entropie",
        "bits": "Bits",
        "very_weak": "Sehr schwach",
        "weak": "Schwach",
        "fair": "Ausreichend",
        "strong": "Stark",
        "very_strong": "Sehr stark"
    },
    "footer": {
        "imprint": "Impressum",
        "terms_of_use": "AGB",
        "privacy_notice": "Datenschutzerklärung",
    },
    "app": {
        "close_remote_access": "Fernzugriff schließen"
    },
    "tokens": {
        "fetch_user_failed": "Konto konnte nicht abgerufen werden. Bitte lade die Seite neu.",
        "fetch_tokens_failed": "Token konnten nicht abgerufen werden. Bitte lade die Seite neu.",
        "unexpected_error": "Ein unerwarteter Fehler ist aufgetreten. Bitte lade die Seite neu.",
        "create_token_failed": "Token konnte nicht erstellt werden. Bitte lade die Seite neu.",
        "delete_token_failed": "Token konnte nicht gelöscht werden. Bitte lade die Seite neu.",
        "info_heading": "Was Autorisierungstoken ermöglichen",
        "info_body": "Autorisierungstoken erlauben es Geräte hinzuzufügen, ohne dein Passwort zu teilen. Einmal-Token verfallen direkt nach der ersten Verwendung, wiederverwendbare Token bleiben aktiv, bis du sie löschst. \n\n Alternativ kannst dich auch mit deiner E-Mail-Adresse und Passwort im Webinterface des Gerätes anmelden, um es mit deinem Konto zu verbinden.",
        "copy_success": "Erfolg",
        "copy_success_text": "Token in die Zwischenablage kopiert",
        "copy_failed": "Token konnte nicht kopiert werden",
        "add_device": "Gerät hinzufügen",
        "create_token": "Autorisierungstoken erstellen",
        "use_once": "Einmal verwendbar",
        "name": "Name",
        "name_placeholder": "Name",
        "created": "Erstellt",
        "used": "Verwendet",
        "last_used": "Zuletzt verwendet",
        "never_used": "Nie",
        "create": "Token erstellen",
        "existing_tokens": "Vorhandene Token",
        "reusable": "Wiederverwendbar",
        "copy": "Kopieren",
        "delete": "Löschen",
        "single_use_description": "Dieses Token kann nur einmal verwendet werden und läuft nach der ersten Verwendung automatisch ab",
        "multi_use_description": "Dieses Token kann mehrfach verwendet werden, bis es manuell gelöscht wird",
        "sort_label": "Token sortieren",
        "sort_created_desc": "Neueste zuerst",
        "sort_created_asc": "Älteste zuerst",
        "sort_name_asc": "Name A-Z",
        "sort_name_desc": "Name Z-A",
        "sort_last_used_desc": "Kürzlich verwendet",
        "search_label": "Token suchen",
        "search_placeholder": "Nach Name suchen...",
        "no_tokens": "Noch keine Token vorhanden. Erstelle oben ein Token, um zu starten.",
        "no_tokens_search": "Keine Token entsprechen deiner Suche.",
        firmware_needed,
        "decrypt_name_failed": "Token-Name konnte nicht entschlüsselt werden."
    },
    "wg_client": {
        "not_initialized": "Der WireGuard-Client ist nicht initialisiert. Bitte lade die Seite neu."
    },
    "version_checker": {
        "new_version_available": "Eine neue Version der Anwendung ist verfügbar. Jetzt neu laden, um die neuesten Funktionen und Fehlerbehebungen zu erhalten?",
        "already_latest": "Du verwendest bereits die neueste Version.",
        "new_version_confirm": "Eine neue Version ist verfügbar. Jetzt neu laden?"
    },
    "iframe": {
        "error_message": "Fernzugriff kann nicht in einem iframe ausgeführt werden"
    },
    "android_smart_banner": {
        "close": "Schließen",
        "text": "Hol dir die App",
        "view": "Ansehen"
    },
    "provisioning": {
        "title": "Gerät einrichten",
        "provisioning_hint": "Ein neues Gerät? Scanne den QR-Code, um es deinem Konto hinzuzufügen.",
        "provisioning_button": "Per QR-Code hinzufügen"
    },
    "local_devices": {
        "title": "Lokales Netzwerk",
        "searching": "Suche nach Geräten im lokalen Netzwerk...",
        "none_found": "Keine Geräte im lokalen Netzwerk gefunden.",
        "connect": "Verbinden",
        "firmware": "Firmware"
    }
};
